(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-candle-offer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-candle-offer')) customElements.define('bb-candle-offer', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.group=4; this.existing=[]; this.loaded=false; this.eligible=JSON.parse(this.querySelector('[data-eligible]').textContent); this.ready=true; this.busy=false; this.uncertain=false;
    this.copy=JSON.parse(this.querySelector('[data-copy]').textContent);
    this.cards=[...this.querySelectorAll('[data-card]')]; this.quantities=new Map();
    this.surpriseCopy=JSON.parse(this.querySelector('[data-surprise-copy]').textContent);
    this.querySelector('[data-surprise-tools]').hidden=false;
    this.querySelector('[data-surprise]').addEventListener('click',()=>this.surprise());
    this.querySelector('[data-surprise-undo]').addEventListener('click',()=>{
      if(!this.surprisePrevious||this.busy||this.uncertain)return;
      this.quantities=new Map(this.surprisePrevious);this.surprisePrevious=null;this.render();
      this.querySelector('[data-surprise-message]').textContent=this.surpriseCopy.undone;
    });
    this.money=new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency:this.dataset.currency});
    this.cards.forEach(card=>card.querySelector('.bb-offer__controls').hidden=false);
    this.querySelector('[data-search]').addEventListener('input',()=>this.filter());
    this.querySelector('[data-format]').addEventListener('change',()=>this.filter());
    this.addEventListener('click',event=>{
      const button=event.target.closest('[data-delta]');
      if (!button || this.busy || this.uncertain) return;
      this.surprisePrevious=null;this.querySelector('[data-surprise-message]').textContent='';
      const id=button.closest('[data-card]').dataset.id;
      this.quantities.set(id,Math.min(99,Math.max(0,(this.quantities.get(id)||0)+Number(button.dataset.delta))));
      this.render();
    });
    this.querySelector('[data-review]').addEventListener('click',()=>this.querySelector('.bb-offer__summary').scrollIntoView({behavior:'smooth',block:'start'}));
    this.querySelector('[data-submit]').addEventListener('click',()=>this.add());
    this.render(); this.refreshBasket().catch(()=>{this.uncertain=true;this.querySelector('[data-message]').textContent=this.copy.error;this.render();});
  }
  async refreshBasket(){
    const response=await fetch(this.dataset.root.replace(/\/$/,'')+'/cart.js',{cache:'no-store'});if(!response.ok)throw new Error('cart');
    const cart=await response.json();this.existing=cart.items.filter(i=>this.eligible.includes(i.product_id)&&!i.selling_plan_allocation);this.loaded=true;this.render();
  }
  surprise(){
    if(!this.loaded||this.busy||this.uncertain)return;
    const base=new Map(this.surprisePrevious||this.quantities);
    const inBasket=new Map();this.existing.forEach(i=>inBasket.set(String(i.variant_id),(inBasket.get(String(i.variant_id))||0)+i.quantity));
    const count=[...base.values()].reduce((a,b)=>a+b,0)+this.existing.reduce((a,i)=>a+i.quantity,0);
    const needed=this.group-count%this.group;
    const pool=this.cards.filter(c=>!c.hidden&&(base.get(c.dataset.id)||0)+(inBasket.get(c.dataset.id)||0)<Number(c.dataset.stock));
    for(let i=pool.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[pool[i],pool[j]]=[pool[j],pool[i]];}
    pool.sort((a,b)=>Number((base.get(a.dataset.id)||0)+(inBasket.get(a.dataset.id)||0)>0)-Number((base.get(b.dataset.id)||0)+(inBasket.get(b.dataset.id)||0)>0));
    if(pool.length<needed){this.querySelector('[data-surprise-message]').textContent=this.surpriseCopy.limited;return;}
    this.surprisePrevious=base;this.quantities=new Map(base);
    const picks=pool.slice(0,needed);picks.forEach(c=>this.quantities.set(c.dataset.id,(this.quantities.get(c.dataset.id)||0)+1));
    this.render();
    const reveal=this.querySelector('[data-surprise-message]');reveal.replaceChildren();
    const title=document.createElement('p');title.textContent=this.surpriseCopy.reveal;reveal.append(title);
    const scents=document.createElement('ul');
    picks.forEach(card=>{
      const item=document.createElement('li');
      const name=document.createElement('span');name.textContent=card.dataset.name;item.append(name);
      const notes=card.querySelector('.bb-candle-notes,.bb-pickmix-notes,.bb-wax-notes')?.textContent.trim();
      if(notes){const profile=document.createElement('span');profile.className='bb-offer__surprise-notes';profile.textContent=notes;item.append(profile);}
      scents.append(item);
    });
    reveal.append(scents);
    const review=document.createElement('p');review.textContent=this.surpriseCopy.review;reveal.append(review);
  }
  filter(){
    const search=this.querySelector('[data-search]').value.trim().toLocaleLowerCase();
    const format=this.querySelector('[data-format]').value;
    this.cards.forEach(c=>c.hidden=!(c.dataset.name.toLocaleLowerCase().includes(search)&&(format==='all'||c.dataset.format===format)));
    this.querySelector('[data-none]').hidden=this.cards.some(c=>!c.hidden);
  }
  render(){
    this.querySelector('[data-surprise]').disabled=!this.loaded||this.busy||this.uncertain||!this.cards.length;
    this.querySelector('[data-surprise]').textContent=this.surprisePrevious?this.surpriseCopy.again:this.surpriseCopy.button;
    this.querySelector('[data-surprise-undo]').hidden=!this.surprisePrevious;
    this.querySelector('[data-surprise-undo]').disabled=this.busy||this.uncertain;

    const prices=[];let newCount=0;this.existing.forEach(i=>{for(let n=0;n<i.quantity;n++)prices.push(i.original_price);});const list=this.querySelector('[data-selection]');list.replaceChildren();this.existing.forEach(i=>{const li=document.createElement('li');li.textContent=i.quantity+' × '+i.product_title+(i.variant_title?' · '+i.variant_title:'')+' ('+this.copy.already+')';list.append(li);});
    this.cards.forEach(c=>{
      const q=this.quantities.get(c.dataset.id)||0;newCount+=q;c.querySelector('output').textContent=q;c.dataset.selected=String(q>0);
      c.querySelectorAll('[data-delta]').forEach(b=>b.disabled=this.busy||this.uncertain||(Number(b.dataset.delta)<0?q===0:q===99));
      for(let i=0;i<q;i++) prices.push(Number(c.dataset.price));
      if(q){const li=document.createElement('li');li.textContent=q+' × '+c.dataset.name+' · '+c.querySelector('.bb-offer__format').textContent;list.append(li);}
    });
    prices.sort((a,b)=>a-b);const count=prices.length;const free=Math.floor(count/this.group);
    const subtotal=prices.reduce((a,b)=>a+b,0);const saving=prices.slice(0,free).reduce((a,b)=>a+b,0);
    this.querySelector('[data-subtotal]').textContent=this.money.format(subtotal/100);
    this.querySelector('[data-saving]').textContent=this.money.format(saving/100);
    this.querySelector('[data-total]').textContent=this.money.format((subtotal-saving)/100);
    this.querySelector('[data-empty]').hidden=count>0;
    this.querySelector('[data-progress]').value=count&&count%this.group===0?this.group:count%this.group;
    this.querySelector('[data-progress-text]').textContent=count+' '+this.copy.count+' · '+free+' '+this.copy.unlocked+'. '+(this.group-count%this.group)+' '+this.copy.remaining+'.';
    this.querySelector('[data-submit]').disabled=!newCount||!this.loaded||this.busy||this.uncertain;
    this.querySelector('[data-submit]').textContent=this.busy?this.copy.busy:this.copy.submit;
    this.querySelector('[data-mobile-total]').textContent=count+' '+this.copy.count+' · '+free+' '+this.copy.unlocked;
    this.querySelector('.bb-offer__mobile').hidden=!count;
  }
  async add(){
    if(this.busy||this.uncertain)return;
    const items=[...this.quantities].filter(([,q])=>q>0).map(([id,quantity])=>({id:Number(id),quantity}));if(!items.length)return;
    this.busy=true;this.render();this.querySelector('[data-message]').textContent='';
    try{
      const response=await fetch(this.dataset.root.replace(/\/$/,'')+'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:['cart-icon-bubble']})});
      if(!response.ok)throw new Error('unconfirmed');
      const added=await response.json();if(added.sections?.['cart-icon-bubble']){const fragment=new DOMParser().parseFromString(added.sections['cart-icon-bubble'],'text/html');const current=document.getElementById('cart-icon-bubble');if(current)current.innerHTML=fragment.body.innerHTML;}this.quantities.clear();this.surprisePrevious=null;this.querySelector('[data-surprise-message]').textContent='';await this.refreshBasket();this.querySelector('[data-message]').textContent=this.copy.success;
    }catch(error){this.uncertain=true;this.querySelector('[data-message]').textContent=this.copy.error;}
    finally{this.busy=false;this.render();}
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-pickmix-offer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-pickmix-offer')) customElements.define('bb-pickmix-offer', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.group=5; this.existing=[]; this.loaded=false; this.eligible=JSON.parse(this.querySelector('[data-eligible]').textContent); this.ready=true; this.busy=false; this.uncertain=false;
    this.copy=JSON.parse(this.querySelector('[data-copy]').textContent);
    this.cards=[...this.querySelectorAll('[data-card]')]; this.quantities=new Map();
    this.surpriseCopy=JSON.parse(this.querySelector('[data-surprise-copy]').textContent);
    this.querySelector('[data-surprise-tools]').hidden=false;
    this.querySelector('[data-surprise]').addEventListener('click',()=>this.surprise());
    this.querySelector('[data-surprise-undo]').addEventListener('click',()=>{
      if(!this.surprisePrevious||this.busy||this.uncertain)return;
      this.quantities=new Map(this.surprisePrevious);this.surprisePrevious=null;this.render();
      this.querySelector('[data-surprise-message]').textContent=this.surpriseCopy.undone;
    });
    this.money=new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency:this.dataset.currency});
    this.cards.forEach(card=>card.querySelector('.bb-offer__controls').hidden=false);
    this.querySelector('[data-search]').addEventListener('input',()=>this.filter());

    this.addEventListener('click',event=>{
      const button=event.target.closest('[data-delta]');
      if (!button || this.busy || this.uncertain) return;
      this.surprisePrevious=null;this.querySelector('[data-surprise-message]').textContent='';
      const id=button.closest('[data-card]').dataset.id;
      this.quantities.set(id,Math.min(99,Math.max(0,(this.quantities.get(id)||0)+Number(button.dataset.delta))));
      this.render();
    });
    this.querySelector('[data-review]').addEventListener('click',()=>this.querySelector('.bb-offer__summary').scrollIntoView({behavior:'smooth',block:'start'}));
    this.querySelector('[data-submit]').addEventListener('click',()=>this.add());
    this.render(); this.refreshBasket().catch(()=>{this.uncertain=true;this.querySelector('[data-message]').textContent=this.copy.error;this.render();});
  }
  async refreshBasket(){
    const response=await fetch(this.dataset.root.replace(/\/$/,'')+'/cart.js',{cache:'no-store'});if(!response.ok)throw new Error('cart');
    const cart=await response.json();this.existing=cart.items.filter(i=>this.eligible.includes(i.product_id)&&!i.selling_plan_allocation);this.loaded=true;this.render();
  }
  surprise(){
    if(!this.loaded||this.busy||this.uncertain)return;
    const base=new Map(this.surprisePrevious||this.quantities);
    const inBasket=new Map();this.existing.forEach(i=>inBasket.set(String(i.variant_id),(inBasket.get(String(i.variant_id))||0)+i.quantity));
    const count=[...base.values()].reduce((a,b)=>a+b,0)+this.existing.reduce((a,i)=>a+i.quantity,0);
    const needed=this.group-count%this.group;
    const pool=this.cards.filter(c=>!c.hidden&&(base.get(c.dataset.id)||0)+(inBasket.get(c.dataset.id)||0)<Number(c.dataset.stock));
    for(let i=pool.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[pool[i],pool[j]]=[pool[j],pool[i]];}
    pool.sort((a,b)=>Number((base.get(a.dataset.id)||0)+(inBasket.get(a.dataset.id)||0)>0)-Number((base.get(b.dataset.id)||0)+(inBasket.get(b.dataset.id)||0)>0));
    if(pool.length<needed){this.querySelector('[data-surprise-message]').textContent=this.surpriseCopy.limited;return;}
    this.surprisePrevious=base;this.quantities=new Map(base);
    const picks=pool.slice(0,needed);picks.forEach(c=>this.quantities.set(c.dataset.id,(this.quantities.get(c.dataset.id)||0)+1));
    this.render();
    const reveal=this.querySelector('[data-surprise-message]');reveal.replaceChildren();
    const title=document.createElement('p');title.textContent=this.surpriseCopy.reveal;reveal.append(title);
    const scents=document.createElement('ul');
    picks.forEach(card=>{
      const item=document.createElement('li');
      const name=document.createElement('span');name.textContent=card.dataset.name;item.append(name);
      const notes=card.querySelector('.bb-candle-notes,.bb-pickmix-notes,.bb-wax-notes')?.textContent.trim();
      if(notes){const profile=document.createElement('span');profile.className='bb-offer__surprise-notes';profile.textContent=notes;item.append(profile);}
      scents.append(item);
    });
    reveal.append(scents);
    const review=document.createElement('p');review.textContent=this.surpriseCopy.review;reveal.append(review);
  }
  filter(){
    const search=this.querySelector('[data-search]').value.trim().toLocaleLowerCase();
    const format='all';
    this.cards.forEach(c=>c.hidden=!(c.dataset.name.toLocaleLowerCase().includes(search)&&(format==='all'||c.dataset.format===format)));
    this.querySelector('[data-none]').hidden=this.cards.some(c=>!c.hidden);
  }
  render(){
    this.querySelector('[data-surprise]').disabled=!this.loaded||this.busy||this.uncertain||!this.cards.length;
    this.querySelector('[data-surprise]').textContent=this.surprisePrevious?this.surpriseCopy.again:this.surpriseCopy.button;
    this.querySelector('[data-surprise-undo]').hidden=!this.surprisePrevious;
    this.querySelector('[data-surprise-undo]').disabled=this.busy||this.uncertain;

    const prices=[];let newCount=0;this.existing.forEach(i=>{for(let n=0;n<i.quantity;n++)prices.push(i.original_price);});const list=this.querySelector('[data-selection]');list.replaceChildren();this.existing.forEach(i=>{const li=document.createElement('li');li.textContent=i.quantity+' × '+i.product_title+(i.variant_title?' · '+i.variant_title:'')+' ('+this.copy.already+')';list.append(li);});
    this.cards.forEach(c=>{
      const q=this.quantities.get(c.dataset.id)||0;newCount+=q;c.querySelector('output').textContent=q;c.dataset.selected=String(q>0);
      c.querySelectorAll('[data-delta]').forEach(b=>b.disabled=this.busy||this.uncertain||(Number(b.dataset.delta)<0?q===0:q===99));
      for(let i=0;i<q;i++) prices.push(Number(c.dataset.price));
      if(q){const li=document.createElement('li');li.textContent=q+' × '+c.dataset.name+' · '+c.querySelector('.bb-offer__format').textContent;list.append(li);}
    });
    prices.sort((a,b)=>a-b);const count=prices.length;const free=Math.floor(count/this.group);
    const subtotal=prices.reduce((a,b)=>a+b,0);const saving=prices.slice(0,free).reduce((a,b)=>a+b,0);
    this.querySelector('[data-subtotal]').textContent=this.money.format(subtotal/100);
    this.querySelector('[data-saving]').textContent=this.money.format(saving/100);
    this.querySelector('[data-total]').textContent=this.money.format((subtotal-saving)/100);
    this.querySelector('[data-empty]').hidden=count>0;
    this.querySelector('[data-progress]').value=count&&count%this.group===0?this.group:count%this.group;
    this.querySelector('[data-progress-text]').textContent=count+' '+this.copy.count+' · '+free+' '+this.copy.unlocked+'. '+(this.group-count%this.group)+' '+this.copy.remaining+'.';
    this.querySelector('[data-submit]').disabled=!newCount||!this.loaded||this.busy||this.uncertain;
    this.querySelector('[data-submit]').textContent=this.busy?this.copy.busy:this.copy.submit;
    this.querySelector('[data-mobile-total]').textContent=count+' '+this.copy.count+' · '+free+' '+this.copy.unlocked;
    this.querySelector('.bb-offer__mobile').hidden=!count;
  }
  async add(){
    if(this.busy||this.uncertain)return;
    const items=[...this.quantities].filter(([,q])=>q>0).map(([id,quantity])=>({id:Number(id),quantity}));if(!items.length)return;
    this.busy=true;this.render();this.querySelector('[data-message]').textContent='';
    try{
      const response=await fetch(this.dataset.root.replace(/\/$/,'')+'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:['cart-icon-bubble']})});
      if(!response.ok)throw new Error('unconfirmed');
      const added=await response.json();if(added.sections?.['cart-icon-bubble']){const fragment=new DOMParser().parseFromString(added.sections['cart-icon-bubble'],'text/html');const current=document.getElementById('cart-icon-bubble');if(current)current.innerHTML=fragment.body.innerHTML;}this.quantities.clear();this.surprisePrevious=null;this.querySelector('[data-surprise-message]').textContent='';await this.refreshBasket();this.querySelector('[data-message]').textContent=this.copy.success;
    }catch(error){this.uncertain=true;this.querySelector('[data-message]').textContent=this.copy.error;}
    finally{this.busy=false;this.render();}
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-wax-offer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-wax-offer')) customElements.define('bb-wax-offer', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.group=5; this.existing=[]; this.loaded=false; this.eligible=JSON.parse(this.querySelector('[data-eligible]').textContent); this.ready=true; this.busy=false; this.uncertain=false;
    this.copy=JSON.parse(this.querySelector('[data-copy]').textContent);
    this.cards=[...this.querySelectorAll('[data-card]')]; this.quantities=new Map();
    this.surpriseCopy=JSON.parse(this.querySelector('[data-surprise-copy]').textContent);
    this.querySelector('[data-surprise-tools]').hidden=false;
    this.querySelector('[data-surprise]').addEventListener('click',()=>this.surprise());
    this.querySelector('[data-surprise-undo]').addEventListener('click',()=>{
      if(!this.surprisePrevious||this.busy||this.uncertain)return;
      this.quantities=new Map(this.surprisePrevious);this.surprisePrevious=null;this.render();
      this.querySelector('[data-surprise-message]').textContent=this.surpriseCopy.undone;
    });
    this.money=new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency:this.dataset.currency});
    this.cards.forEach(card=>card.querySelector('.bb-offer__controls').hidden=false);
    this.querySelector('[data-search]').addEventListener('input',()=>this.filter());

    this.addEventListener('click',event=>{
      const button=event.target.closest('[data-delta]');
      if (!button || this.busy || this.uncertain) return;
      this.surprisePrevious=null;this.querySelector('[data-surprise-message]').textContent='';
      const id=button.closest('[data-card]').dataset.id;
      this.quantities.set(id,Math.min(99,Math.max(0,(this.quantities.get(id)||0)+Number(button.dataset.delta))));
      this.render();
    });
    this.querySelector('[data-review]').addEventListener('click',()=>this.querySelector('.bb-offer__summary').scrollIntoView({behavior:'smooth',block:'start'}));
    this.querySelector('[data-submit]').addEventListener('click',()=>this.add());
    this.render(); this.refreshBasket().catch(()=>{this.uncertain=true;this.querySelector('[data-message]').textContent=this.copy.error;this.render();});
  }
  async refreshBasket(){
    const response=await fetch(this.dataset.root.replace(/\/$/,'')+'/cart.js',{cache:'no-store'});if(!response.ok)throw new Error('cart');
    const cart=await response.json();this.existing=cart.items.filter(i=>this.eligible.includes(i.product_id)&&!i.selling_plan_allocation);this.loaded=true;this.render();
  }
  surprise(){
    if(!this.loaded||this.busy||this.uncertain)return;
    const base=new Map(this.surprisePrevious||this.quantities);
    const inBasket=new Map();this.existing.forEach(i=>inBasket.set(String(i.variant_id),(inBasket.get(String(i.variant_id))||0)+i.quantity));
    const count=[...base.values()].reduce((a,b)=>a+b,0)+this.existing.reduce((a,i)=>a+i.quantity,0);
    const needed=this.group-count%this.group;
    const pool=this.cards.filter(c=>!c.hidden&&(base.get(c.dataset.id)||0)+(inBasket.get(c.dataset.id)||0)<Number(c.dataset.stock));
    for(let i=pool.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[pool[i],pool[j]]=[pool[j],pool[i]];}
    pool.sort((a,b)=>Number((base.get(a.dataset.id)||0)+(inBasket.get(a.dataset.id)||0)>0)-Number((base.get(b.dataset.id)||0)+(inBasket.get(b.dataset.id)||0)>0));
    if(pool.length<needed){this.querySelector('[data-surprise-message]').textContent=this.surpriseCopy.limited;return;}
    this.surprisePrevious=base;this.quantities=new Map(base);
    const picks=pool.slice(0,needed);picks.forEach(c=>this.quantities.set(c.dataset.id,(this.quantities.get(c.dataset.id)||0)+1));
    this.render();
    const reveal=this.querySelector('[data-surprise-message]');reveal.replaceChildren();
    const title=document.createElement('p');title.textContent=this.surpriseCopy.reveal;reveal.append(title);
    const scents=document.createElement('ul');
    picks.forEach(card=>{
      const item=document.createElement('li');
      const name=document.createElement('span');name.textContent=card.dataset.name;item.append(name);
      const notes=card.querySelector('.bb-candle-notes,.bb-pickmix-notes,.bb-wax-notes')?.textContent.trim();
      if(notes){const profile=document.createElement('span');profile.className='bb-offer__surprise-notes';profile.textContent=notes;item.append(profile);}
      scents.append(item);
    });
    reveal.append(scents);
    const review=document.createElement('p');review.textContent=this.surpriseCopy.review;reveal.append(review);
  }
  filter(){
    const search=this.querySelector('[data-search]').value.trim().toLocaleLowerCase();
    const format='all';
    this.cards.forEach(c=>c.hidden=!(c.dataset.name.toLocaleLowerCase().includes(search)&&(format==='all'||c.dataset.format===format)));
    this.querySelector('[data-none]').hidden=this.cards.some(c=>!c.hidden);
  }
  render(){
    this.querySelector('[data-surprise]').disabled=!this.loaded||this.busy||this.uncertain||!this.cards.length;
    this.querySelector('[data-surprise]').textContent=this.surprisePrevious?this.surpriseCopy.again:this.surpriseCopy.button;
    this.querySelector('[data-surprise-undo]').hidden=!this.surprisePrevious;
    this.querySelector('[data-surprise-undo]').disabled=this.busy||this.uncertain;

    const prices=[];let newCount=0;this.existing.forEach(i=>{for(let n=0;n<i.quantity;n++)prices.push(i.original_price);});const list=this.querySelector('[data-selection]');list.replaceChildren();this.existing.forEach(i=>{const li=document.createElement('li');li.textContent=i.quantity+' × '+i.product_title+(i.variant_title?' · '+i.variant_title:'')+' ('+this.copy.already+')';list.append(li);});
    this.cards.forEach(c=>{
      const q=this.quantities.get(c.dataset.id)||0;newCount+=q;c.querySelector('output').textContent=q;c.dataset.selected=String(q>0);
      c.querySelectorAll('[data-delta]').forEach(b=>b.disabled=this.busy||this.uncertain||(Number(b.dataset.delta)<0?q===0:q===99));
      for(let i=0;i<q;i++) prices.push(Number(c.dataset.price));
      if(q){const li=document.createElement('li');li.textContent=q+' × '+c.dataset.name+' · '+c.querySelector('.bb-offer__format').textContent;list.append(li);}
    });
    prices.sort((a,b)=>a-b);const count=prices.length;const free=Math.floor(count/this.group);
    const subtotal=prices.reduce((a,b)=>a+b,0);const saving=prices.slice(0,free).reduce((a,b)=>a+b,0);
    this.querySelector('[data-subtotal]').textContent=this.money.format(subtotal/100);
    this.querySelector('[data-saving]').textContent=this.money.format(saving/100);
    this.querySelector('[data-total]').textContent=this.money.format((subtotal-saving)/100);
    this.querySelector('[data-empty]').hidden=count>0;
    this.querySelector('[data-progress]').value=count&&count%this.group===0?this.group:count%this.group;
    this.querySelector('[data-progress-text]').textContent=count+' '+this.copy.count+' · '+free+' '+this.copy.unlocked+'. '+(this.group-count%this.group)+' '+this.copy.remaining+'.';
    this.querySelector('[data-submit]').disabled=!newCount||!this.loaded||this.busy||this.uncertain;
    this.querySelector('[data-submit]').textContent=this.busy?this.copy.busy:this.copy.submit;
    this.querySelector('[data-mobile-total]').textContent=count+' '+this.copy.count+' · '+free+' '+this.copy.unlocked;
    this.querySelector('.bb-offer__mobile').hidden=!count;
  }
  async add(){
    if(this.busy||this.uncertain)return;
    const items=[...this.quantities].filter(([,q])=>q>0).map(([id,quantity])=>({id:Number(id),quantity}));if(!items.length)return;
    this.busy=true;this.render();this.querySelector('[data-message]').textContent='';
    try{
      const response=await fetch(this.dataset.root.replace(/\/$/,'')+'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:['cart-icon-bubble']})});
      if(!response.ok)throw new Error('unconfirmed');
      const added=await response.json();if(added.sections?.['cart-icon-bubble']){const fragment=new DOMParser().parseFromString(added.sections['cart-icon-bubble'],'text/html');const current=document.getElementById('cart-icon-bubble');if(current)current.innerHTML=fragment.body.innerHTML;}this.quantities.clear();this.surprisePrevious=null;this.querySelector('[data-surprise-message]').textContent='';await this.refreshBasket();this.querySelector('[data-message]').textContent=this.copy.success;
    }catch(error){this.uncertain=true;this.querySelector('[data-message]').textContent=this.copy.error;}
    finally{this.busy=false;this.render();}
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
